/// <reference path='../../../../../../typings/index.d.ts' />
/// <reference path="../../../docsAndForms/docs-and-forms.service.ts" />

module Meevo.Plugins.ClientIntakeForm {

    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import IFormBuilderModel = Meevo.Plugins.DocsAndForms.IFormBuilderModel;
    import DocsAndFormsService = Meevo.Plugins.DocsAndForms.DocsAndFormsService;

    class UserDefinedFieldsComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            'meevo.plugins.clientIntakeForm.ClientIntakeFormService',
            'meevo.plugins.docsAndForms.DocsAndFormsService',
        ];

        public formBuilderModel: IFormBuilderModel;
        public docsAndFormsModel: IIntakeFormModel;
        public disabled: boolean;
        private udfs: IUserDefinedControl[];

        constructor(private $scope: ng.IScope,
                    private dataService: ClientIntakeFormService,
                    protected docsAndFormsService: Meevo.Plugins.DocsAndForms.DocsAndFormsService) {
        }

        public $onInit() {
            this.loadUserDefinedFields();
            this.initializeWatchers();
        }

        private loadUserDefinedFields(): void {
            this.dataService.getUdfControls()
                .then((res) => {
                    this.udfs = res;
                });
        }

        private updateUsableItems(data: IUserDefinedControl[] = this.formBuilderModel.assignedUDFs): void {
            this.formBuilderModel.assignedUDFs = this.docsAndFormsService.populateAssignedUdfs(data, this.docsAndFormsModel);
        }

        private initializeWatchers() {
            this.$scope.$watch(() => this.formBuilderModel, () => {
                this.updateUsableItems(this.udfs);
            });
        }
    }

    angular.module('meevo.plugins.clientIntakeForm')
        .component('clientIntakeFormUserDefinedFields', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/clientIntakeForm/components/userDefinedFields/userDefinedFields.component.html',
            controller: UserDefinedFieldsComponent,
            controllerAs: '$ctrl',
            bindings: {
                formBuilderModel: '=',
                docsAndFormsModel: '=',
                disabled: '=?ngDisabled',
            }
        });

}
